import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomLogisticsTable from "../../CustomLogisticsTable";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import updateIcon from "../../../../../Assets/icons/check-circle (8) 1.svg";
import DetailsTable from "../PurchaseOrderDetails/PurchaseOrder/DetailsTable";
import ListLogisticsFilters from "../../LogisticsFilter";
// import { IoCheckmarkSharp } from "react-icons/io5";
// import PhysicalStockin from '../PhysicalStock-in';

const PartSpecific = () => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ filterFormData, setFilterFormData ] = useState({});
  const [quantities, setQuantities] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
 // const location = useLocation();

  const [editRowId, setEditRowId] = useState(null); // Track the row being edited
  const [editedQuantity, setEditedQuantity] = useState({}); // Track edited quantity for the specific row

  const [editRow, setEditRow] = useState(null);
  //   const []

  const [businessPartnerIdState, setBusinessPartnerIdState] = useState(null);
  // const [PhysicalStockinId,setPhysicalStockinId] = useState(0)
  const [productdetails, setProductDetails] = useState([]);
  const token = localStorage.getItem("authToken");
 
const navigate = useNavigate()
  const location = useLocation();
  const data  = location.state || {};
  console.log("location>>",location);
  
  const POID = data?.POID || data?.poID;
  console.log("locationdata<><><>", POID);

//   useEffect(() => {
//     fetchPoApprovalDetailsEdit();
//   }, []);

//   const fetchPoApprovalDetailsEdit = async () => {
//     try {
//       const response = await axiosInstance.get(
//         `/purchaseorder/edit/${data.po_id}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const fetchedData = response.data.data;

//       console.log(fetchedData, "FETCHEDDATA");
//       setPoApprovalEdit(fetchedData);
//       const poIdVal = response.data.data.po_id;
//       console.log(poIdVal, "POVALID");
//       setPoId(poIdVal);

//       console.log(formData, "depatartment DATA");
//     } catch (error) {
//       console.log(error);
//     }
//   };

  useEffect(() => {
      fetchProductDetails();
    },[]);
    const handleSearch=()=>{
    
    //console.log(filterFormData,'filterFormData/////////////////')
    fetchProductDetails();
        
    }

  const fetchProductDetails = async (page = 0, pageSize = 5) => {
    try {
      const response = await axiosInstance.post(
        "/purchaseorder/vendorwiseitemlist",
        {
            business_partner_id:1,
            stock_type: filterFormData?.potype,
            orderBy:"logistic_id desc",
            page:0,
            pageSize:10
        },
      
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data;

      console.log(response, "formatdata");
      setProductDetails(formattedData);

      const quantities = formattedData.map((item) => item.po_details_id);
      console.log(quantities, "QuantValues");

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductDetails(newPage);
  };

  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Vendor Name",
    "Item Name",
    "Unit",
    "Price Per Unit",
    "Avl. Quantity",
    "Order Quantity",
    "Product",
    "Variant",
    "Price",
    "Total Price",
  
  ];

  const DEPARTMENT_KEY_MAPPING = {
    "Vendor Name":"vendor_name",
    "Item Name":"item_name",
    "Unit":"unit",
    "Price Per Unit":"purchase_price",
    "Avl. Quantity":"avl_qty",
    "Order Quantity":"order_quantity",
    "Product":"product_name",
    "Variant":"variant_name",
    "Price":"purchase_price",
    "Total Price":"total_price",
  
   'Action': [
      {
        type: 'edit',
        label: 'Edit',
        icon: editIcon,
      },
      
     
    ]
  };
  const filtersInputs = [
    {
      name: "potype",
      label: "PO Type",
      placeholder:"PO Type",
      type: "radio",
      options:[{value:"S", label:"Spare Parts"},{value:"A", label:"Accessories"},],
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "search",
      label: "Search",
      type: "text",
      placeholder:"Search Accessories",
      required: false,
      gridClass: "col-lg-4",
  },
   
   
  ]
 
  const handleEditClick = (row) => {
    console.log(row.po_details_id, "row");
   setEditRow(row.po_details_id)
    setEditRowId(row.item_id); // Set the specific row in edit mode
    setEditedQuantity({ [row.po_details_id]: row.qty_approved }); // Initialize with the current quantity for the specific row
  };
 

  const handleSave = async (row) => {
    
    console.log(
      "Saving Quantity for row:",
      row.editRowId,
      "New Quantity:",
      editedQuantity[row.editRowId]
    );

    const rowToUpdate = productdetails.find(
      (item) => item.editRowId === row.editRowId
    );

    if (rowToUpdate) {
      const newQuantity = editedQuantity[row.editRowId];

      const total = newQuantity * rowToUpdate.rate;
      const taxAmountValue = total * rowToUpdate.tax;
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;

      // Prepare payload for saving
      const payload = {
        qty_approved: newQuantity,
        totalprice: String(newTotalPrice),
        taxset_amount: String(newTaxAmount),
      };

      try {
        const response = await axiosInstance.patch(
          `/purchaseorderapproval/update/${row.po_details_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "EDITQUANTRESPONSE");

        setProductDetails((prevDetails) =>
          prevDetails.map((item) =>
            item.po_details_id === row.po_details_id
              ? {
                  ...item,
                  qty_approved: newQuantity,
                  totalprice: newTotalPrice,
                  taxset_amount: newTaxAmount,
                }
              : item
          )
        );
      } catch (error) {
        console.log(error);
      }

      // After saving, reset the edit state
      setEditRowId(null);
    }
  };
  

  const handleClear =  () => {
  
    setFilterFormData({})
    //setFilters({});

  
    
  };

  return (
    <div>
      <div className="">
        <div
          style={{
            paddingBottom: "35px",
            borderBottom: "1px solid lightgray",
            padding: "35px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                fontWeight: "300",
                fontSize: "12px",
                paddingBottom: "5px",
                color: "gray",
                paddingLeft: "15px",
              }}
            >
              Logistics / Purchased Orders / New Purchase Order / Purchase Orders-Part Specific
            </span>
            <div className="backbutton" >
              <img src={backicon} alt="back" onClick={()=>navigate(-1)} />
              <span className="backbtntitleDetails"> PO Part Specific Details</span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            {/* <button
              className="clear-btn"
              style={{
                padding: "12px 28px",
                borderRadius: "38px",
                color: "green",
              }}
            >
              Back
            </button> */}
            {/* <button
              className="flte-btn"
              style={{ padding: "12px 18px", borderRadius: "38px" }}
              onClick={handleApprove}
            >
              Approve
            </button> */}
          </div>
        </div>

        <div>
          <div className="">
            <h5
              style={{ paddingLeft: "55px" }}
              className="mt-2 mb-2 header-details"
            >
             Part Specific Purchase Order
            </h5>
            <ListLogisticsFilters
            formConfig={filtersInputs} 
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch} 
            handleClear={handleClear}
            />

            <div style={{ paddingTop: "14px" }}>
              <DetailsTable
                data={productdetails}
                headers={DEPARTMENT_TABLE_HEADERS}
                keyMapping={DEPARTMENT_KEY_MAPPING}
                itemsPerPage={10}
                onPageChange={handlePageChange}
                handleEditClick={handleEditClick}
               // handleQuantityChange={handleQuantityChange}
                handleSave={handleSave}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                quantities={quantities}
                setQuantities={setQuantities}
                editedQuantity={editedQuantity}
                setEditedQuantity={setEditedQuantity}
                updateIcon={updateIcon}
                POID={POID}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartSpecific;
